import React, { useState, useEffect } from 'react'
import '../../css/admin/AdminDashboard.css'
import { AiOutlinePlusCircle, AiOutlineDelete } from 'react-icons/ai';
import { FaTimes } from 'react-icons/fa';
import axios from "axios";
import { useNavigate } from 'react-router-dom'
import ToastNotification from '../../components/ToastNotification';
import { FaEye, FaEyeSlash } from "react-icons/fa";


const Companies = ({adminData,companyID,branchID}) => {

    const [detail, setDetail] = useState([]);
    const [search, setSearch] = useState("");
    const [showConfirm, setShowConfirm] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [editingCompanyId, setEditingCompanyId] = useState(null);
    const navigate = useNavigate()
    const [oldFiles, setOldFiles] = useState({});
    const [searchTerm, setSearchTerm] = useState('');
   const [showPassword, setShowPassword] = useState(false);

    const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
    const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
    };


    const [form, setForm] = useState({
        name: '',
        email: '',
        phone: '',
        company_id: '',
        password: '',
        address: '',
        city: '',
        state: '',
        short_name: '',
        role: '',
        fax: '',
        url: '',
        pan: '',
        gst: '',
        esic_no: '',
        esic_acct: '',
        bank_name: '',
        branch: '',
        esic_office: '',
        acc_no: '',
        pf_no: '',
        ifsc: '',
        pincode: '',
        aadhaar: ''




    });

    const [files, setFiles] = useState({
        gst_img: null,
        gomashta_img: null,
        visiting_img: null,
        bill_img: null,
        owner_pan_img: null,
        owner_aadhaar_img: null,
        owner_aadhaar_back: null

    });



    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };


    const handleFileChange = (e) => {
        const { name, files: selectedFiles } = e.target;

        if (selectedFiles && selectedFiles.length > 0) {
            const file = selectedFiles[0];

   
            const maxSizeMB = 2;
            if (file.size / 1024 / 1024 > maxSizeMB) {
                alert(`File size should be less than ${maxSizeMB} MB`);
                return;
            }

            setFiles((prevFiles) => ({
                ...prevFiles,
                [name]: file, 
            }));
        }
    };

    const handleEdit = (form) => {

        setForm({
            id: form.id || '',
            name: form.name || "",
            email: form.email || "",
            phone: form.phone || "",
            password: form.password || "",
            address: form.address || "",
            city: form.city || "",
            state: form.state || "",
            company_id: form.company_id || "",
            short_name: form.short_name || "",
            role: form.role || "",
            gst: form.gst || "",
            bank_name: form.bank_name || "",
            acc_no: form.acc_no || "",
            branch: form.branch || "",
            ifsc: form.ifsc || "",
            esic_no: form.esic_no || "",
            esic_acct: form.esic_acct || "",
            esic_office: form.esic_office || "",
            pan: form.pan || "",
            aadhaar: form.aadhaar || "",
            pf_no: form.pf_no || "",
            fax: form.fax || "",
            url: form.url || "",
            pincode: form.pincode || '',
        });

        setFiles({
            gst_img: form.gst_img || null,
            gomashta_img: form.gomashta_cer || null,
            visiting_img: form.visiting_card || null,
            bill_img: form.bill_book || null,
            owner_pan_img: form.owner_pan || null,
            owner_aadhaar_img: form.owner_aadhaar || null,
            owner_aadhaar_back: form.owner_aadhaar_back || null
        });

        setEditingCompanyId(form.id);
        setIsEditMode(true);
        setShowForm(true);
    };

    // Delete company
    const handleDelete = async (company_id) => {


        try {
            const deleteCompany = await axios.delete(`https://api.skyguard.group/api/delete-company/${company_id}`);

            // Remove deleted company from state
            setDetail((prev) => prev.filter((com) => com.company_id !== company_id));
            showToast("Company deleted successfully", 'success');
        } catch (err) {
            console.error("Error deleting company:", err);
            showToast("Failed to delete company", 'danger');
        }
    };

    useEffect(() => {
        fecthDetail();
    }, []);


    const fecthDetail = async () => {
        try {
            const resDetail = await axios.get('https://api.skyguard.group/api/fetch-detail');

            setDetail(resDetail.data.result);
        } catch (error) {
            console.log(error)
        }
    };
  
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isEditMode) {

            const data = new FormData();

            Object.keys(form).forEach(key => data.append(key, form[key]));
            Object.keys(files).forEach(key => {
                if (files[key] instanceof File) {
                    data.append(key, files[key]); // only new files
                }
            });

            try {
                await axios.put(`https://api.skyguard.group/api/edit-company/${form.company_id}`, data, {
                    headers: { "Content-Type": "multipart/form-data" }
                });
                showToast("Company updated successfully", 'success');
                fecthDetail();

                setShowForm(false);
                   resetForm();
            } catch (err) {
                console.error(err);
                showToast("Failed to update company", 'danger');
            }

        } else {


            const formData = new FormData();

        
            formData.append("name", form.name || '');
            formData.append("email", form.email || '');
            formData.append("phone", form.phone || '');
            formData.append("company_id", form.company_id || '');
            formData.append("password", form.password || '');
            formData.append("address", form.address || '');
            formData.append("city", form.city || '');
            formData.append("state", form.state || '');
            formData.append("short_name", form.short_name || '');
            formData.append("role", form.role || '');
            formData.append("fax", form.fax || '');
            formData.append("url", form.url || '');
            formData.append("pan", form.pan || '');
            formData.append("gst", form.gst || '');
            formData.append("esic_no", form.esic_no || '');
            formData.append("esic_acct", form.esic_acct || '');
            formData.append("bank_name", form.bank_name || '');
            formData.append("branch", form.branch || '');
            formData.append("esic_office", form.esic_office || '');
            formData.append("acc_no", form.acc_no || '');
            formData.append("pf_no", form.pf_no || '');
            formData.append("ifsc", form.ifsc || '');
            formData.append("pincode", form.pincode || '');
            formData.append("aadhaar", form.aadhaar || '');

            // append files
            Object.keys(files).forEach((key) => {
                if (files[key]) {
                    formData.append(key, files[key]);
                }
            });


            try {
                const res = await axios.post(
                    "https://api.skyguard.group/api/add-company",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );
                
                showToast("Company added successfully!", 'success');
                fecthDetail();
                setShowForm(false);

            } catch (error) {
                console.error("❌ Error:", error.response?.data || error.message);
                showToast("Error adding company", 'danger');
            }



        }

      resetForm();

    };


    const handleDeleteClick = (id) => {
        setDeleteId(id);       
        setShowConfirm(true);  
    };

    const confirmDelete = () => {
        handleDelete(deleteId);
        setShowConfirm(false);  
    };
    const filterCompany = detail.filter((tt) => {
        const term = searchTerm.toLowerCase();

        return (
            (tt.pincode && tt.pincode.toLowerCase().includes(term)) ||
            (tt.name && tt.name.toString().toLowerCase().includes(term)) ||
            (tt.phone && tt.phone.toString().toLowerCase().includes(term))
        );
    });


    const resetForm = () =>{

          setForm({
            name: '',
            email: '',
            phone: '',
            company_id: '',
            password: '',
            address: '',
            city: '',
            state: '',
            short_name: '',
            role: '',
            fax: '',
            url: '',
            pan: '',
            gst: '',
            esic_no: '',
            esic_acct: '',
            bank_name: '',
            branch: '',
            esic_office: '',
            acc_no: '',
            pf_no: '',
            ifsc: '',
            pincode: ''
        })
      setFiles({
            gst_img: null,
            gomashta_img: null,
            visiting_img: null,
            bill_img: null,
            owner_pan_img: null,
            owner_aadhaar_img: null,
            owner_aadhaar_back: null
        })
        setIsEditMode(false);
        setEditingCompanyId(null);
            setShowForm(false);
    }

    return (
        <div className='main-section'>
            <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>

                <ToastNotification
                    show={toast.show}
                    message={toast.message}
                    bg={toast.bg}
                    onClose={() => setToast({ ...toast, show: false })}
                />
                <h3 className='my-3 fw-bold fs-5 golos'>Companies</h3>

                <div className='mb-3 d-flex flex-wrap align-items-end justify-content-between'>

                    <div className="mb-2 w-50 w-md-50 pe-md-2">
                        <input className="form-control w-100" list="datalistOptions" id="exampleDataList" placeholder="Search by Company Name,Phone..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>

                    <div className="mb-2">

                        <button
                            className={`btn  ${showForm ? 'btn-danger' : 'btn-success'}`}
                            onClick={() => {
                                setShowForm(!showForm);
                             
                            }}
                        >
                            {showForm ? (
                                <>
                                    Close <FaTimes size={20} />
                                </>
                            ) : (
                                <>
                                    Add <AiOutlinePlusCircle size={22} />
                                </>
                            )}
                        </button>
                    </div>

                </div>

                {showForm && (
                    <div className='card p-3 mb-3'>
                        <form onSubmit={handleSubmit} >

                            <h5 className="mt-3 ">Basic Info</h5>
                       {isEditMode && (
  <div className="mb-3">
    <label>Company  Name:</label> <br />
    <span className="badge bg-primary px-3 py-2">
     {form.name}
    </span>
  </div>
)}
                            <hr />

                            <div className='row g-3'>
                                <div className="col-md-4">
                                    <label>Name</label>
                                    <input type="text" className="form-control" name="name" placeholder="Name" value={form.name} onChange={handleInputChange} required />
                                </div>
                                <div className="col-md-4">
                                    <label>Email</label>
                                    <input type="email" className="form-control" name="email" placeholder="Email" value={form.email} onChange={handleInputChange} required />
                                </div>
                                <div className="col-md-4">
                                    <label>Phone</label>
                                    <input type="number" className="form-control" name="phone" placeholder="Phone No" value={form.phone} onChange={handleInputChange} required maxLength={10} />
                                </div>

                            
<div className="col-md-4">
  <label>Password</label>

  <div className="position-relative">
    <input
      type={showPassword ? "text" : "password"}
      className="form-control pe-5"
      name="password"
      placeholder="Password"
      value={form.password}
      onChange={handleInputChange}
      required
    />

    <span
      onClick={() => setShowPassword(!showPassword)}
      style={{
        position: "absolute",
        right: "15px",
        top: "50%",
        transform: "translateY(-50%)",
        cursor: "pointer",
        color: "#6c757d",
        zIndex: 10,
      }}
    >
      {showPassword ? <FaEyeSlash /> : <FaEye />}
    </span>
  </div>
</div>
                                <div className="col-md-4">
                                    <label>Address</label>
                                    <input type="text" className="form-control" name="address" placeholder="address" value={form.address} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <label>City</label>
                                    <input type="text" className="form-control" name="city" placeholder="city" value={form.city} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <label>State</label>
                                    <input type="text" className="form-control" name="state" placeholder="state" value={form.state} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <label>Pincode</label>
                                    <input type="text" className="form-control" name="pincode" placeholder="Pincode" value={form.pincode} onChange={handleInputChange} />
                                </div>


                                <h5 className="mt-4">Company Details</h5>
                                <hr />
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <label>Company ID</label>
                                        <input type="text" className="form-control" name="company_id" placeholder="Company ID" value={form.company_id} onChange={handleInputChange} required />
                                    </div>
                                    <div className="col-md-4">
                                        <label>Short Name</label>
                                        <input type="text" className="form-control" name="short_name" placeholder="Company Short Name" value={form.short_name} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label>Role</label>
                                        <input type="text" className="form-control" name="role" placeholder="Role" value={form.role} onChange={handleInputChange} required />
                                    </div>
                                    <div className="col-md-4">
                                        <label>Enter Your GST Number</label>
                                        <input type="text" className="form-control" name="gst" placeholder="GST" value={form.gst} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label" > Upload your GST image or pdf</label>
                                        {isEditMode && files.gst_img && typeof files.gst_img === "string" && (
                                            <div style={{ marginBottom: 10 }}>
                                                <span>Previous file: </span>
                                                <a
                                                    href={`https://api.skyguard.group/uploads/${files.gst_img}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {files.gst_img}
                                                </a>
                                            </div>
                                        )}



                                        <input type="file" className="form-control   " name="gst_img" accept="image/*,application/pdf"
                                            onChange={handleFileChange}

                                        />
                                    </div>

                                </div>

                                <h5 className="mt-4">Bank Details</h5>
                                <hr />
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <label>Bank Name</label>
                                        <input type="text" className="form-control" name="bank_name" placeholder="Bank Name" value={form.bank_name} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label>Account Number</label>
                                        <input type="text" className="form-control" name="acc_no" placeholder="Account Number" value={form.acc_no} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label>Bank Branch</label>
                                        <input type="text" className="form-control" name="branch" placeholder="Branch" value={form.branch} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label>IFSC</label>
                                        <input type="text" className="form-control" name="ifsc" placeholder="IFSC" value={form.ifsc} onChange={handleInputChange} />
                                    </div>


                                </div>

                                <h5 className="mt-4">ESIC Details</h5>
                                <hr />
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <label>ESIC Number</label>
                                        <input type="text" className="form-control" name="esic_no" placeholder="ESIC Number" value={form.esic_no} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label>ESIC Account</label>
                                        <input type="text" className="form-control" name="esic_acct" placeholder="ESIC Account" value={form.esic_acct} onChange={handleInputChange} />
                                    </div>

                                    <div className="col-md-4">
                                        <label>ESIC Office </label>
                                        <input type="text" className="form-control" name="esic_office" placeholder="ESIC Office" value={form.esic_office} onChange={handleInputChange} />
                                    </div>

                                </div>

                                <h5 className="mt-4">Pan Details</h5>
                                <hr />
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <label>Enter Your Pan</label>
                                        <input type="text" className="form-control" name="pan" placeholder="Pan" value={form.pan} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label>Upload Your Pan</label>

                                        {isEditMode && files.owner_pan_img && typeof files.owner_pan_img == "string" && (
                                            <div style={{ marginBottom: 10 }}>
                                                <span>Previous file: </span>
                                                <a
                                                    href={`https://api.skyguard.group/uploads/${files.owner_pan_img}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {files.owner_pan_img}
                                                </a>
                                            </div>
                                        )}

                                        <input type="file" className="form-control" name="owner_pan_img" accept="image/*,application/pdf" placeholder="acc_no"
                                            onChange={handleFileChange}

                                        />
                                    </div>

                                </div>
                                <h5 className="mt-4">Aadhar Details</h5>
                                <hr />
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <label>Enter Your Aadhaar Number</label>
                                        <input type="number" className="form-control" name="aadhaar" placeholder="Aahaar Number" value={form.aadhaar} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label>Upload Your Front Aadhaar Image</label>
                                        {isEditMode && files.owner_aadhaar_img && typeof files.owner_aadhaar_img === "string" && (
                                            <div style={{ marginBottom: 10 }}>
                                                <span>Previous file: </span>
                                                <a
                                                    href={`https://api.skyguard.group/uploads/${files.owner_aadhaar_img}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {files.owner_aadhaar_img}
                                                </a>
                                            </div>
                                        )}


                                        <input type="file" className="form-control" name="owner_aadhaar_img" accept="image/*,application/pdf" placeholder="acc_no"
                                            onChange={handleFileChange}
                                        // onChange={(e) =>
                                        //     setFiles({ ...files, owner_aadhaar_img: e.target.files[0] })
                                        // }
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label>Upload Your Back Aadhaar Image</label>

                                        {isEditMode && files.owner_aadhaar_back && typeof files.owner_aadhaar_back === "string" && (
                                            <div style={{ marginBottom: 10 }}>
                                                <span>Previous file: </span>
                                                <a
                                                    href={`https://api.skyguard.group/uploads/${files.owner_aadhaar_back}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {files.owner_aadhaar_back}
                                                </a>
                                            </div>
                                        )}

                                        <input type="file" className="form-control" name="owner_aadhaar_back" accept="image/*,application/pdf" placeholder="acc_no"
                                            onChange={handleFileChange}
                                        />
                                    </div>
                                </div>

                                <h5 className="mt-4">Other Details</h5>
                                <hr />
                                <div className="row g-3">

                                    <div className="col-md-4">
                                        <label>PF Number </label>
                                        <input type="text" className="form-control" name="pf_no" placeholder="PF Number" value={form.pf_no} onChange={handleInputChange} />
                                    </div>



                                    <div className="col-md-4">
                                        <label>Fax </label>
                                        <input type="text" className="form-control" name="fax" placeholder="Fax" value={form.fax} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label>URL </label>
                                        <input type="text" className="form-control" name="url" placeholder="URL" value={form.url} onChange={handleInputChange} />
                                    </div>

                                </div>

                                <h5 className="mt-4">Upload Documents</h5>
                                <hr />
                                <div className="row g-3">

                                    <div className="col-md-4">
                                        <label>Upload your Gomashta Certificate</label>


                                        {isEditMode && files.gomashta_img && typeof files.gomashta_img === "string" && (
                                            <div style={{ marginBottom: 10 }}>
                                                <span>Previous file: </span>
                                                <a
                                                    href={`https://api.skyguard.group/uploads/${files.gomashta_img}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {files.gomashta_img}
                                                </a>
                                            </div>
                                        )}

                                        <input type="file" className="form-control" name="gomashta_img" accept="image/*,application/pdf" placeholder="acc_no" onChange={handleFileChange} />
                                    </div>

                                    <div className="col-md-4">
                                        <label>Upload ypur Visiting Card</label>

                                        {isEditMode && files.visiting_img && typeof files.visiting_img === "string" && (
                                            <div style={{ marginBottom: 10 }}>
                                                <span>Previous file: </span>
                                                <a
                                                    href={`https://api.skyguard.group/uploads/${files.visiting_img}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {files.visiting_img}
                                                </a>
                                            </div>
                                        )}

                                        <input type="file" className="form-control" name="visiting_img" accept="image/*,application/pdf" onChange={handleFileChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label>Upload Your Bill Book</label>

                                        {isEditMode && files.bill_img && typeof files.bill_img === "string" && (
                                            <div style={{ marginBottom: 10 }}>
                                                <span>Previous file: </span>
                                                <a
                                                    href={`https://api.skyguard.group/uploads/${files.bill_img}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {files.bill_img}
                                                </a>
                                            </div>
                                        )}

                                        <input type="file" className="form-control" name="bill_img" accept="image/*,application/pdf" onChange={handleFileChange} />
                                    </div>
                                </div>


                                <div className="col-md-12 text-end">
                                    {/* <button className='btn btn-primary' type='submit' >
                                        Submit
                                    </button> */}
                                    <button type="submit" className='btn btn-success w-10'>
                                        {isEditMode ? "Update" : "Save"}
                                    </button>
                                    <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                                        setShowForm(false);
                                        setIsEditMode(false);
                                           resetForm();
                                    }}>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </form>

                    </div>
                )}

          
                <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                    <table className='table table-bordered table-striped table-hover text-center align-middle'>
                        <thead className='table-info'>
                            <tr>
                                     <th scope='col'>Action</th>
                                <th scope='col'>Name</th>
                                <th scope='col'>GST No</th>
                                <th scope='col'>Phone No</th>
                                <th scope='col'>Company ID</th>
                                <th scope='col'>Password</th>
                            </tr>
                        </thead>
                        <tbody>




                            {filterCompany
                                .filter((form) =>
                                    search.trim() === ""
                                        ? true // if search is empty, show all rows
                                        : form.name?.toLowerCase().includes(search.toLowerCase())
                                )
                                .map((form) => (
                                    <tr key={form.id}>
                                             <td>
                                            <button
                                                className="btn btn-primary"
                                                onClick={() => handleEdit(form)}
                                            >
                                                Edit
                                            </button>
                                            &nbsp;
                                            <button
                                                className="btn btn-danger"
                                                onClick={() => handleDeleteClick(form.company_id)}
                                            >
                                                <AiOutlineDelete size={20} />
                                            </button>



                                        </td>
                                        <td>{form.name}</td>
                                        <td>{form.gst}</td>
                                        <td>{form.phone}</td>
                                        <td>{form.company_id}</td>
                                        <td>{form.password}</td>


                                   
                                    </tr>
                                ))}



                            {showConfirm && (
                                <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                                    <div className="modal-dialog modal-sm " role="document">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title">Confirm Delete</h5>
                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    onClick={() => setShowConfirm(false)}
                                                ></button>
                                            </div>
                                            <div className="modal-body">
                                                <p>Are you sure you want to delete this company?</p>
                                            </div>
                                            <div className="modal-footer">
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary"
                                                    onClick={() => setShowConfirm(false)}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-danger"
                                                    onClick={confirmDelete}
                                                >
                                                    OK
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}



                            {filterCompany.length === 0 && (
                                <tr>
                                    <td colSpan="9">No companies found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Companies;
